export const LabsMasterWidgetConfig = [
    { span: 24, height: "40px", classes: "marginTop-16" },
    {
        classes: "marginTop-16 flex",
        columns: [
            { height: "160px", span: 4 },
            { height: "160px", span: 4 },
            { height: "160px", span: 4 },
            { height: "160px", span: 4 },
            { height: "160px", span: 4 },
            { height: "160px", span: 4 },
        ],
    },
    // Slider indicator bar (full width)
    { span: 24, height: "8px", classes: "marginTop-16" },
]
